import { graphqlRequest } from 'src/app/graphqlClient';
import { gql } from 'graphql-request';

import { EventServicePageNameTypes } from './apiTypes';

export const getSelectedColumns = async (payload: { userId: number; pageName: EventServicePageNameTypes }) => {
    const queryString = `
        query GetSelectedColumnsAndFilters($userId: Int!, $pageName: page_name_type!) {
            events_db {
                table_settings(where: {page_name: {_eq: $pageName}, user_id: {_eq: $userId}}) {
                    order,
                    filters,
                    sort_field
                }
            }
        }
    `;
    const variables = { userId: payload.userId, pageName: payload.pageName };
    const response = await graphqlRequest({ document: queryString, variables });
    return response.events_db;
};

export const updateSelectedColumns = async (payload: { pageName: EventServicePageNameTypes; columnData: string[]; userId: number }) => {
    const insertMutationString = gql`
        mutation UpsertSelectedColumnsMutation($order: [String!], $pageName: page_name_type!) {
            events_db {
                insert_table_settings(objects: { order: $order, page_name: $pageName }, on_conflict: { constraint: table_settings_pkey, update_columns: order }) {
                    affected_rows
                }
            }
        }
    `;
    const response = await graphqlRequest({ document: insertMutationString, variables: { order: payload.columnData, pageName: payload.pageName } });
    return response.events_db;
};
